import { AnyRoute, createRoute, redirect } from '@tanstack/react-router'
import { routes } from 'commons/constants/routes'

import { AnnualReviewWrapper } from './AnnualReviewWrapper'
import { annualReviewDetailsRoute } from './Routes/AnnualReview/AnnualReviewDetail'
import { annualReviewEditRoute } from './Routes/AnnualReview/AnnualReviewEdit'
import { annualReviewSalesDepositsRoute } from './Routes/AnnualReview/AnnualReviewSalesDeposits'

export const routeAnnualReviewsTree = <T extends AnyRoute>(rootRoute: T) => {
  const annualReviewsIndexRoute = createRoute({
    beforeLoad: async ({ context }) => {
      if (!context.accessibleRoutingFlags.annualReviewRootAccess) {
        throw redirect({
          to: '/'
        })
      }
    },
    getParentRoute: () => rootRoute,
    path: 'annual-review',
    component: AnnualReviewWrapper
  })

  const annualReviewSalesDepositsOldRoute = createRoute({
    getParentRoute: () => annualReviewsIndexRoute,
    path: routes.bank.annualReview.salesDepositsOldRoute,
    beforeLoad: ({ params }) => {
      throw redirect({
        to: '/annual-review/$annualReviewId/edit-sales-and-deposit/$id',
        params: { annualReviewId: params.annualReviewId, id: params.salesAndDepositId }
      })
    }
  })

  return annualReviewsIndexRoute.addChildren([
    annualReviewSalesDepositsOldRoute,
    annualReviewEditRoute<typeof annualReviewsIndexRoute>(annualReviewsIndexRoute),
    annualReviewSalesDepositsRoute<typeof annualReviewsIndexRoute>(annualReviewsIndexRoute),
    annualReviewDetailsRoute<typeof annualReviewsIndexRoute>(annualReviewsIndexRoute)
  ])
}
